"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorPageContent = require("./ErrorPageContent");
Object.keys(_ErrorPageContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPageContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPageContent[key];
    }
  });
});
